export const TYPE_SUCCESS_WITHOUT_MODERATION = 'SuccessWithoutModeration';
export const TYPE_SUCCESS_WITH_MODERATION = 'SuccessWithModeration';
export const TYPE_DEFAULT_ERROR = 'DefaultError';

export const notificationTypes = {
    [TYPE_SUCCESS_WITHOUT_MODERATION]: {
        title: 'registration.success2',
        message: 'registration.success.message',
    },
    [TYPE_SUCCESS_WITH_MODERATION]: {
        title: 'registration.successPremoderate',
        message: 'registration.successPremoderate.message',
    },
    [TYPE_DEFAULT_ERROR]: {
        title: 'auth.login.email.registrationFail',
        message: '',
    },
};
